//
//  KentaroBloodPressure.ts
//
//  isana.net,inc. Proprietary and Confidential
//

class KentaroBloodPressure {
  readonly REGEX =
    /ID (\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}) SYS(\d{2,3})mmHg DIA(\d{2,3})mmHg PR(\d{2,3})bpm MOV(\d{1})/;

  readonly orginal: string;
  readonly dateStr: string;
  readonly max: number;
  readonly min: number;
  readonly pulse: number;

  constructor(text: string) {
    const matched = text.match(this.REGEX);
    if (!matched) {
      throw new Error("Invalid text");
    }
    this.orginal = text;
    this.dateStr = this.convertDateString(matched[1]);
    this.max = parseInt(matched[2]);
    this.min = parseInt(matched[3]);
    this.pulse = parseInt(matched[4]);
  }

  // YYYY/MM/DD HH:mm -> YYYY-MM-DD
  convertDateString(date: string): string {
    const [year, month, day] = date.split(/[\/ ]/);
    return `${year}-${month}-${day}`;
  }
}

export default KentaroBloodPressure;
